import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ContactUsRoutingModule } from "./contact-us-routing.module";
import { ContactUsComponent } from "./contact-us.component";
import { TranslateModule } from "@ngx-translate/core";
import { AgmCoreModule } from "@agm/core";

@NgModule({
  declarations: [ContactUsComponent],
  imports: [
    CommonModule,
    ContactUsRoutingModule,
    TranslateModule.forChild(),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyBrxbO_MPRJaqZoq8PckmeGmpNJGNxdgRw"
    })
  ]
})
export class ContactUsModule {}
